module.exports = __webpack_public_path__ + "static/media/iConnectance.fc3f544b.png";